import Swiper from 'swiper'
import 'swiper/css'

export class IndexBnrSlider {
  constructor() {
    if (document.getElementById('js-index_bnr') === null) return
    const IndexBnr = new Swiper('#js-index_bnr', {
      slidesPerView: 1.5,
      spaceBetween: 15,
      loop: true,
      breakpoints: {
        767: {
          slidesPerView: 2.2,
        },
        1024: {
          slidesPerView: 3.25,
          spaceBetween: 30,
        },
        1600: {
          slidesPerView: 4.2,
          spaceBetween: 30,
        },
      },
    })
  }
}
